export default "__VITE_ASSET__BDBdJl0n__"